export default __webpack_public_path__ + "static/amazon-promo-2024--desktop-59affd119c50a289ccaca9a6cd7e789c.jpg";